<template
>
    <div class="pa-5">
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Created at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.created_at ? activeOnboarding.created_at : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Updated at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.updated_at ? activeOnboarding.updated_at : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Company name" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.name ? activeOnboarding.name : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Legal type" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{
                    activeOnboarding.legal_type
                            ? activeOnboarding.legal_type.charAt(0).toUpperCase() + activeOnboarding.legal_type.slice(1)
                            : "-"
                }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Identification code" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.identification_code ? activeOnboarding.identification_code : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Status" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.status ? activeOnboarding.status : "-" }}
                <span
                        v-if="activeOnboarding.status"
                        :style="{ 'background-color': getStatusColor(activeOnboarding.status) }"
                        class="dot"
                ></span>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Contact address" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.contact_address ? activeOnboarding.contact_address : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Country" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.country ? activeOnboarding.country : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Field of activity" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.field_of_activity ? activeOnboarding.field_of_activity : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Email" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.email ? activeOnboarding.email : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Phone number" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.phone_nr ? activeOnboarding.phone_nr : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Has politically exposed person" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.has_politically_exposed_person ? 'Yes' : 'No' }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Agreed terms" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.agreed_terms ? 'Yes' : 'No' }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Postback method" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.postback_method ? activeOnboarding.postback_method : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Postback URL" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.postback_url ? activeOnboarding.postback_url : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Postback sent at" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.postback_sent_at ? activeOnboarding.postback_sent_at : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "External document ID" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ activeOnboarding.ext_document_id ? activeOnboarding.ext_document_id : "-" }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Related company ID" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ getCompanyName(activeOnboarding.related_company_id) }}
            </v-col>
        </v-row>
        <v-row>
            <v-col class="col-item row-title" cols="3">{{ "Parent company ID" | t }}</v-col>
            <v-col class="col-item" cols="6">
                {{ getCompanyName(activeOnboarding.parent_company_id) }}
            </v-col>
        </v-row>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "general-info-view-tab",
    computed: {
        ...mapState(["companies"]),
        ...mapState('onboarding', ['activeOnboarding'])
    },
    methods: {
        getCompanyName(id) {
            if (!id) {
                return '-';
            }

            const company = this.companies.find(c => c.id === id);

            if (company) return company.name;

            try {
                return Number(id)
            } catch {
                return "-";
            }
        },
        getStatusColor(status) {
            if (status === "confirmed") {
                return "#4CAF50";
            } else if (["failed", "cancelled"].includes(status)) {
                return "#FF0000";
            } else if (status === "completed") {
                return "#0066ff";
            } else if (status === "pending") {
                return "#eec01f";
            } else {
                return "#999999";
            }
        },
    }
};
</script>

<style scoped>
.row-title {
    color: gray;
}
</style>
